export class SalesforceChat {
  settings: any;
  initOptions: any;

  constructor(props: any) {
    this.settings = props.settings;
    this.initOptions = props.initOptions;
  }
}

export default SalesforceChat;
